<ion-header>
	<ion-toolbar>
		<ion-title>{{ 'Messages' | translate}}</ion-title>
		<ion-buttons slot="end" (click)="!requesting && dismiss()">
			<ion-button color="dark">
				<ion-icon name="close-circle"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>
<ng-container *ngIf="requesting">
	<ion-progress-bar type="indeterminate"></ion-progress-bar>
</ng-container>
<ion-content class="ion-padding-bottom">
	<ion-refresher slot="fixed" (ionRefresh)="!requesting && dismiss()">
	</ion-refresher>
	<ion-list>
		<ng-container *ngFor="let chat of chats">
			<ion-item detail="true" (click)="openChat(chat)">
				<app-avatar [data]="chat.chatter" [type]="chat.chatter_type" [favorite]="!!chat.chatter?.favorite_company_id"
					slot="start">
				</app-avatar>
				<ion-label>
					{{ chat.chatter?.name }}
					<p class="truncate">
						{{ chat.message }}
					</p>
					<p *ngIf="chat.messaged_at">
						{{ chat.messaged_at | chatDatetime }}
					</p>
				</ion-label>
				<ion-badge slot="end" *ngIf="chat.unread_messages">
					{{ chat.unread_messages }}
				</ion-badge>
			</ion-item>
		</ng-container>
		<app-list-status [requesting]="requesting" [data]="chats">
		</app-list-status>
	</ion-list>
	<ion-infinite-scroll threshold="10px" (ionInfinite)="index()" class="scroll-height">
	</ion-infinite-scroll>
</ion-content>